export default __webpack_public_path__ + "static/media/Head_1_Ear_3_C2.c579d064.svg";